import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import adminConfigRoleManagement from '../../staticRoleManagement/adminConfigRoleManagement'
import AdminConfigAuthenticationHistoryTab from '../AdminConfigAuthenticationHistory'
import AdminConfigLogTab from '../AdminConfigLog'
import AdminConfigSecurityTab from '../AdminConfigSecurity'
import AdminConfigSessionsTab from '../AdminConfigSessions'
import AdminConfigTenantExportTab from '../AdminConfigTenantExport'
import useStyles from './styles/index.styles'

export default function AdminConfigTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()
  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      value: 'log',
      className: classes.tab,
      label: getTranslate('Log'),
      component: LocalizedLink,
      to: '/admin-config/log'
    },
    {
      value: 'security',
      className: classes.tab,
      label: getTranslate('Security'),
      component: LocalizedLink,
      to: '/admin-config/security'
    },
    {
      value: 'authentication-history',
      className: classes.tab,
      label: getTranslate('Authentication History'),
      component: LocalizedLink,
      to: '/admin-config/authentication-history'
    },
    {
      value: 'tenant-export',
      className: classes.tab,
      label: getTranslate('Data Export'),
      component: LocalizedLink,
      to: '/admin-config/tenant-export'
    },
    {
      value: 'user-sessions',
      className: classes.tab,
      label: getTranslate('Users Sessions'),
      component: LocalizedLink,
      to: '/admin-config/user-sessions'
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = adminConfigRoleManagement.find(
    (item) =>
      item.route ===
      '/admin-config/(log|security|authentication-history|tenant-export|user-sessions)'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              className={tab.className}
              label={tab.label}
              to={tab.to}
              component={LocalizedLink}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="tenant-export"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AdminConfigTenantExportTab />
      </TabPanel>
      <TabPanel
        value={page}
        index="log"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AdminConfigLogTab />
      </TabPanel>
      <TabPanel
        value={page}
        index="security"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AdminConfigSecurityTab />
      </TabPanel>
      <TabPanel
        value={page}
        index="authentication-history"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AdminConfigAuthenticationHistoryTab />
      </TabPanel>
      <TabPanel
        value={page}
        index="user-sessions"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AdminConfigSessionsTab />
      </TabPanel>
    </div>
  )
}
